// extracted by mini-css-extract-plugin
module.exports = {"p":"Text_p__J3RQ7","h1":"Text_h1__3XUHR","h2":"Text_h2__3fxON","h3":"Text_h3__3g6dm"};